import classNames from "classnames/bind";
import { useCallback, useEffect, useRef, useState } from "react";
import styles from "./Notification.module.css";
import { BellIcon } from "../../../../components/Icons/Icons";
import NotificationModal from "./NotifiCationModal";
import { useStoreContext } from "../../../../hooks/useStoreContext";
import ModalSetting from "../../../../pages/Administration/Camera/ModalSetting";
import { cameraManagement } from "../../../../services/api/cameraManagementApi";
import axiosClient_v2 from "../../../../services/axiosClient_v2";
import { Popover } from "antd";

const cx = classNames.bind(styles);
function Notification() {
  const [countNotification, setCountNotifiCation] = useState();
  const [tagActive, setTagActive] = useState("Cảnh báo thông minh");
  const [isScroll, setIsScroll] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [notificationData, setNotificationData] = useState([]);
  const [toggleGetNotification, setToggleGetNotification] = useState(false);
  const [number, setNumber] = useState(5);
  const [isSetting, setIsSetting] = useState({ codeCam: null, show: false });
  const [cameraCurrent, setCameraCurrent] = useState([]);
  const [isRefresh, setIsRefresh] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [refreshCount, setRefreshCount] = useState(false);
  const [nextTime, setNextTime] = useState();
  const [loading, setLoading] = useState(true);
  // eslint-disable-next-line
  const [data, dispatch] = useStoreContext();
  let remoteToggleReGetNotification = data.toggleNotification;
  const handleShowNotification = () => {
    setShowNotification(!showNotification);
  };
  // // console.log(loading);
  const refNotification = useRef(null);

  const handleToggleGetNotification = () => {
    setToggleGetNotification(!toggleGetNotification);
  };

  const handleGetMoreNotification = (more) => {
    // if (number < 50) {
    //   setNumber(number + more);
    if (!isLoading) {
      setIsScroll(!isScroll);
    }
    // }
  };

  const getData = useCallback(async (code) => {
    try {
      if (code) {
        let params = {
          camera_code: code,
        };
        const res = await cameraManagement.getOne(params);
        setCameraCurrent(res);
      }
    } catch (error) { }
  }, []);

  useEffect(() => {
    if (isSetting.codeCam && isSetting.show) {
      getData(isSetting.codeCam);
    }
  }, [isRefresh, isSetting, getData]);

  const showSetting = (code) => {
    setIsSetting({ codeCam: code, show: true });
  };
  const handleClose = () => {
    setIsSetting(false);
  };
  useEffect(() => {
    const getNotification = async () => {
      if (notificationData.length === 0) {
        setLoading(!loading);
      }
      setIsLoading(true);
      try {
        const next_time = nextTime ? { next_time: nextTime } : {};
        const res = await axiosClient_v2.get(
          `/notification/get-list-notification-popup/?size=5&system=${tagActive === "tb" ? 1 : 0}`,
          {
            params: {
              ...next_time,
            },
          }
        );
        setNotificationData((prev) => [...prev, ...res.data]);
        setNextTime(res.next_time);
        setCountNotifiCation(res.count);
        setIsLoading(false);
        setLoading(false);
      } catch (error) {
        setIsLoading(false);
        // // console.log(error);
        setLoading(false);
      }
    };

    getNotification();
  }, [
    toggleGetNotification,
    number,
    remoteToggleReGetNotification,
    tagActive,
    isScroll,
    showNotification
  ]);

  const handleRefreshCount = () => {
    setRefreshCount(!refreshCount);
  };
  return (
    <div className={cx("notification")}>
      <div style={{ cursor: "pointer" }} className={cx("icon-notification")}>
        {/* style={{padding:6,backgroundColor:"#e4e6eb",borderRadius:"50%"}} */}
        <Popover
          content={
            <NotificationModal
              notificationData={notificationData}
              setNotificationData={setNotificationData}
              reGetData={handleToggleGetNotification}
              setNumber={(e) => handleGetMoreNotification(e)}
              dispatch={dispatch}
              tagActive={tagActive}
              setTagActive={setTagActive}
              showSetting={showSetting}
              isLoading={isLoading}
              handleRefreshCount={handleRefreshCount}
              setNextTime={setNextTime}
              loading={loading}
            />}
          trigger="click"
          open={showNotification}
          onOpenChange={handleShowNotification}
        >
          <BellIcon
            className={cx("bell-icon")}
          />
          <span className={cx("mark")}></span>
          <div className={cx("top-box")} ref={refNotification}></div>
          {countNotification > 0 && (
            <span className={cx("number-notification")}>
              {countNotification > 99 ? "99+" : countNotification}
            </span>
          )}
        </Popover>
      </div>
      {isSetting.show && cameraCurrent.length > 0 && (
        <div className={cx("contain")}>
          <ModalSetting
            camera={cameraCurrent}
            onclose={handleClose}
            show={isSetting.show}
            isRefresh={isRefresh}
            setIsRefresh={setIsRefresh}
          />
        </div>
      )}
    </div>
  );
}

export default Notification;
